import { render, staticRenderFns } from "./index-banner.vue?vue&type=template&id=5cfbd1a8&scoped=true&"
import script from "./index-banner.vue?vue&type=script&lang=js&"
export * from "./index-banner.vue?vue&type=script&lang=js&"
import style0 from "./index-banner.vue?vue&type=style&index=0&id=5cfbd1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfbd1a8",
  null
  
)

export default component.exports